import { GetDataOrderListItems } from "services/interface";
import { apiGetShippingQueueStatus, checkShippingItems } from "services/ordersApi";
import { isTruthyShipShop } from "utils/convertData";
import { ShipItemsSummary, hasItemsAwaitingLabel } from "./selfTracking";

/** สูงสุดต่อครั้งเมื่อกด「เลือกทั้งหมดที่ออก Label ได้」(เทียบแท็บรับคำสั่งซื้อ) */
export const PREPARE_SHIP_SELECT_ALL_CAP = 5000;

const QUEUE_STATUS_CHUNK_SIZE = 150;

/** คิวขนส่ง / ออก Label แพลตฟอร์ม — app_agent และ ecommerce_web ที่ไม่ใช่ ship shop */
export function orderUsesPlatformShippingLabel(
  record: Pick<GetDataOrderListItems, "datasource" | "is_ship_shop">
): boolean {
  if (isTruthyShipShop(record)) return false;
  return record.datasource === "app_agent" || record.datasource === "ecommerce_web";
}

/**
 * เลือก checkbox ออก Label ได้เมื่ออยู่ใน flow แพลตฟอร์ม และ queue ยังเป็น none / ยังไม่โหลด
 * และยังมีชิ้นที่ต้องออก Label — ชิ้นส่งเองที่ออก Label/กรอกเลขพัสดุแล้วไม่ต้องออกซ้ำ
 */
export function isOrderSelectableForShippingLabel(
  record: Pick<GetDataOrderListItems, "datasource" | "is_ship_shop" | "order_id">,
  queueStatus: Record<string, string>,
  shipItemsByOrderId: Record<string, ShipItemsSummary> = {}
): boolean {
  if (!orderUsesPlatformShippingLabel(record)) return false;
  if (!hasItemsAwaitingLabel(shipItemsByOrderId[record.order_id])) return false;
  const qStatus = queueStatus[record.order_id];
  return !qStatus || qStatus === "none";
}

export function filterSelectableOrderIds(
  orders: GetDataOrderListItems[],
  queueStatus: Record<string, string>,
  shipItemsByOrderId: Record<string, ShipItemsSummary> = {}
): string[] {
  return orders
    .filter((record) => isOrderSelectableForShippingLabel(record, queueStatus, shipItemsByOrderId))
    .map((record) => record.order_id);
}

export async function fetchShippingQueueStatusMap(
  orderIds: string[]
): Promise<Record<string, string>> {
  const map: Record<string, string> = {};
  for (let i = 0; i < orderIds.length; i += QUEUE_STATUS_CHUNK_SIZE) {
    const chunk = orderIds.slice(i, i + QUEUE_STATUS_CHUNK_SIZE);
    const res = await apiGetShippingQueueStatus(chunk);
    if (res.status === "success" && res.data) {
      Object.assign(map, res.data);
    }
  }
  return map;
}

/** order_id → ผล checkShippingItems (ใช้ตัดออเดอร์ที่ออก Label ครบแล้วออกตอน「เลือกทั้งหมด」) */
export async function fetchShipItemsMap(
  orderIds: string[]
): Promise<Record<string, ShipItemsSummary>> {
  const map: Record<string, ShipItemsSummary> = {};
  for (let i = 0; i < orderIds.length; i += QUEUE_STATUS_CHUNK_SIZE) {
    const chunk = orderIds.slice(i, i + QUEUE_STATUS_CHUNK_SIZE);
    const res = await checkShippingItems(chunk);
    if (res.status === "success" && res.data?.details) {
      for (const d of res.data.details) {
        map[d.order_id] = { y: d.y ?? 0, z: d.z ?? 0, items: d.items };
      }
    }
  }
  return map;
}
